import { useSearchParams } from 'react-router-dom';

export type Country = 'uk' | 'india';

/**
 * Custom hook to get the country parameter from URL query string
 * Defaults to 'uk' if no country parameter is provided or if invalid
 */
export const useCountryParam = (): Country => {
  const [searchParams] = useSearchParams();
  
  const countryParam = searchParams.get('country');
  const normalizedCountry = (countryParam ?? 'uk').toLowerCase();
  
  if (normalizedCountry === 'india' || normalizedCountry === 'uk') {
    return normalizedCountry as Country;
  }
  
  return 'uk'; // Default fallback
};

/**
 * Utility function to build URLs with country parameter
 */
export const buildUrlWithCountry = (basePath: string, country: Country): string => {
  return `${basePath}?country=${country}`;
};